import { Flex, Select, Typography } from 'antd';
import { getFullName } from '../../../utils';
import { useEffect, useState } from 'react';
import { getSalesReps } from '../../../redux/actions/users';
import clsx from 'clsx';

const { Option } = Select;

const SalesRepFilter = ({
    size = 'large',
    placeholder = 'Search Sales Rep',
    onChange,
    value,
    isNetsuiteId = false,
    className,
}) => {
    const [users, setUsers] = useState([]);

    const handleGetUsers = async () => {
        const res = await getSalesReps();
        if (res?.ack) {
            setUsers(res.users || []);
        }
    };

    useEffect(() => {
        handleGetUsers();
    }, []);

    return (
        <Select
            className={clsx(className ?? "lg:max-w-20rem w-full")}
            size={size}
            placeholder={placeholder}
            optionLabelProp="label"
            showSearch
            optionFilterProp="label"
            allowClear
            filterOption={(input, option) =>
                String(option['data-title'] || '')
                    .toLowerCase()
                    .includes(input.toLowerCase()) ||
                String(option['data-code'] || '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
            }
            value={value}
            onChange={onChange}
        >
            {users?.map((user) => (
                <Option
                    key={isNetsuiteId ? user?.netsuite_id : user?.id}
                    value={isNetsuiteId ? user?.netsuite_id : user?.id}
                    label={getFullName(user)}
                    data-code={user?.email}
                    data-title={getFullName(user)}
                >
                    <Flex vertical gap={1}>
                        <Typography.Text>{getFullName(user)}</Typography.Text>
                        <Typography.Text type="secondary">{user.email}</Typography.Text>
                    </Flex>
                </Option>
            ))}
        </Select>
    );
};

export default SalesRepFilter;
